module.exports = __webpack_public_path__ + "fonts/duo_38x38.9944c099fa2327e9e4da2b33c9516593.png?";


//////////////////
// WEBPACK FOOTER
// ./~/@okta/okta-signin-widget/dist/img/icons/mfa/duo_38x38.png
// module id = 753
// module chunks = 9